import React from 'react';
import {Route} from 'react-router-dom';

import * as Screens from './screens';

const routes = [
    <Route
        exact
        path="/administration/analyses"
        component={Screens.List}
        key="analyses-list"
    />,
    <Route
        exact
        path="/administration/analyses/:id/edit"
        component={Screens.Edit}
        key="analyses-edit"
    />,
];

export default routes;
